<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Date">
              <b-datepicker
                v-model="date"
                name="date"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Date"
              />
            </b-field>
            <b-field v-if="hasGroupPlants" label="Plant">
              <b-select v-model="selectedPlant" icon="industry" expanded>
                <option v-for="plant in groupPlants" :key="plant.id" :value="plant">
                  {{ plant.name }}
                </option>
              </b-select>
            </b-field>
            <b-field v-else label="Plant">
              <multiselect
                v-model="selectedPlant"
                :options="plants"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick plant"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
          <b-tabs v-model="activeTab" type="is-toggle" expanded>
            <b-tab-item
              v-for="stock in crateStocks"
              :key="stock.type"
              :value="stock.type"
              :label="stock.type"
              class="card p-3"
            >
              <b-field
                grouped
              >
                <b-field label="Dirty">
                  {{ crateCount(stock, 'DIRTY') }}
                </b-field>
                <b-field label="Clean">
                  {{ crateCount(stock, 'CLEAN') }}
                </b-field>
                <b-field label="Repair">
                  {{ crateCount(stock, 'REPAIR') }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Received Dirty">
                  {{ movementCount(stock, ['forklift__receivedDirty']) }}
                </b-field>
                <b-field label="Received Clean">
                  {{ movementCount(stock, ['forklift__receivedClean']) }}
                </b-field>
                <b-field label="Received to Repair">
                  {{ movementCount(stock, ['forklift__receivedRepair']) }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Delivered Dirty">
                  {{ movementCount(stock, ['forklift__deliveredDirty']) }}
                </b-field>
                <b-field label="Delivered Clean">
                  {{ movementCount(stock, ['forklift__deliveredClean']) }}
                </b-field>
                <b-field label="Delivered to Repair">
                  {{ movementCount(stock, ['forklift__deliveredRepair']) }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Washed">
                  {{ movementCount(stock, ['washing', 'machineWash']) }}
                </b-field>
                <b-field label="Repaired">
                  {{ movementCount(stock, ['repair']) }}
                </b-field>
                <b-field label="Rejected">
                  {{ movementCount(stock, ['forklift__cleanRejectedDirty', 'forklift__cleanRejectedRepair', 'forklift__dirtyRejectedRepair']) }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Doors Repaired">
                  {{ movementCount(stock, ['repair__door']) }}
                </b-field>
              </b-field>
            </b-tab-item>
          </b-tabs>
          <!-- <ag-grid-vue
            v-if="stocks.length != 0"
            style="width: 100%; height: 700px;"
            class="ag-theme-balham"
            :row-data="stocks"
            :grid-options="gridOptions"
            :pagination="true"
            :pagination-auto-page-size="true"
            :side-bar="['columns']"
            :cache-overflow-size="0"
            :multi-sort-key="'ctrl'"
            :modules="modules"
            :get-context-menu-items="getContextMenuItems"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import CrateMovements from '../../services/v3/crateMovements'
import Stock from '../../services/v3/crateStock'
import plantSelector from '@/mixins/plantSelector'
import { restoreConsultingPlant } from '@/helpers/plants'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'CrateStock',
  components: {
  },
  mixins: [plantSelector],
  data: function () {
    return {
      date: new Date(),
      isLoading: false,
      activeTab: '5.2',
      selectedPlant: restoreConsultingPlant(),
      stocks: [],
      crateStocks: [],
      movements: [],
      modules: AllModules,
      gridOptions: {
        cacheBlockSize: 20,
        paginationPageSize: 20,
        enableRangeSelection: true,
        defaultColDef: {
          floatingFilter: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: false,
          resizable: true
        },
        columnDefs: [
          { headerName: 'Crates',
            field: 'num_crates',
            filter: 'agTextColumnFilter',
            width: 130,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Crate Type',
            field: 'type',
            filter: 'agTextColumnFilter',
            width: 130,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Status',
            field: 'status_crates',
            filter: 'agTextColumnFilter',
            width: 130,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    await this.loadPlants()
  },
  methods: {
    resetData () {
      this.stocks = []
    },
    // The tabs come from the site's target stock types while the rows come from the
    // API, so a type can end up with no matching row. Reading through this keeps the
    // tab rendering at 0 instead of throwing on an undefined find() result.
    crateCount (stock, status) {
      const row = stock.stocks.find(x => x.status_crates === status)
      return row ? row.num_crates : 0
    },
    // `5.X` is a virtual type: a site configured with it still records its movements
    // under the real 5.2 and 5.5 types, so both have to fold into that tab. The API
    // already does the same fold for the stock rows it sends back.
    matchesTab (movementType, tabType) {
      if (movementType === tabType) {
        return true
      }
      return tabType === '5.X' && (movementType === '5.2' || movementType === '5.5')
    },
    movementCount (stock, operations) {
      return this.movements
        .filter(x => operations.includes(x.operation) && this.matchesTab(x.type, stock.type))
        .reduce((sum, element) => sum + element.num_crates, 0)
    },
    async getData () {
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      this.isLoading = true
      this.stocks = []
      this.crateStocks = []
      this.movements = []
      this.$buefy.toast.open({ message: 'Loading Data', duration: 10000, type: 'is-success' })
      try {
        const data = await Stock.get({
          date: this.date.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id
        })
        const defaultTypes = ['1', '5.1', '5.2', '5.5']
        let types = defaultTypes
        // A site with no target stock saved leaves `types` null, and JSON.parse(null)
        // would take the whole load down with it instead of falling back.
        if (data.siteData && data.siteData.length > 0 && data.siteData[0].types) {
          try {
            types = JSON.parse(data.siteData[0].types).map(x => x.name)
          } catch (e) {
            types = defaultTypes
          }
        }
        if (!(types && types.length > 0)) {
          types = defaultTypes
        }
        data.stocks.forEach((element, index) => {
          this.stocks.push({
            id: index,
            num_crates: element.num_crates,
            type: element.status.split('__')[0],
            status_crates: element.status.split('__')[1]
          })
        })
        const data2 = await CrateMovements.getTable({
          start: this.date.toLocaleDateString('en-CA'),
          end: this.date.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id
        })
        data2.forEach(element => {
          this.movements.push({
            operation: element.operation,
            num_crates: element.num_crates,
            status_crate_start: element.status_crate_start,
            status_crate_end: element.status_crate_end,
            type: element.status_crate_end.split('__')[0],
            shift: element.shift,
            date: new Date(element.date.split('Z')[0]).toLocaleDateString('en-CA'),
            comment: element.comment
          })
        })
        if (this.stocks.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'Error loading stocks', duration: 3000, type: 'is-danger' })
        }

        types.forEach(element => {
          this.crateStocks.push({
            type: element,
            stocks: this.stocks.filter(x => x.type === element)
          })
        })
        this.activeTab = types[0]
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
      this.isLoading = false
    },
    getContextMenuItems (params) {
      let customMenu = []
      const genericMenu = [
        'separator',
        'copy',
        'copyWithHeaders',
        'separator',
        'export'
      ]
      const result = [...customMenu, ...genericMenu]
      return result
    }
  }
}

</script>
